// extracted by mini-css-extract-plugin
export default {"loader":"src-components-base-SVG-spinnerLoader__bPqOj__loader","ps-loader-l4":"src-components-base-SVG-spinnerLoader__a8eOY__ps-loader-l4"};